import { render, staticRenderFns } from "./PublicSwitches.vue?vue&type=template&id=9a8570ba&scoped=true&"
import script from "./PublicSwitches.vue?vue&type=script&lang=js&"
export * from "./PublicSwitches.vue?vue&type=script&lang=js&"
import style0 from "./PublicSwitches.vue?vue&type=style&index=0&id=9a8570ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8570ba",
  null
  
)

export default component.exports